const SCRIPT_CONTENT = `
// Listen on Exit tags
// Exit tags prevent the click event to be listen with the previous listener, so we should listen on the window.open event
// Here we can have access to the url, but for preview url we generally use the click command.
// We can probably add a custom param in order to allow the AdOps to use the url contains in the html and not the click command from the admin
window.open = function(url) {
  window.parent.postMessage('clickFromIframe', '*');
}
`;

export class WrappedHtml {
  private _document: Document;
  private _body: HTMLElement | null;

  get content(): string {
    return this._document.documentElement.innerHTML;
  }

  constructor(html: string) {
    try {
      this._document = new DOMParser().parseFromString(html, 'text/html');
    } catch (err) {
      throw new Error(`Failed to parse creative html : ${JSON.stringify(err)}`);
    }

    this._body = this._document.querySelector('body');
    if (this._body == null) throw new Error('Failed to find a body tag');

    this.addScriptToBody();
  }

  addScriptToBody(): this {
    const script = this._document.createElement('script');
    script.innerHTML = SCRIPT_CONTENT;
    this._body && this._body.appendChild(script);
    return this;
  }
}
